<template>
  <div
    v-show="hasAdjustments"
    class="sf-pointer sf-level sf-level-between sf-below-1"
    :data-testid="`filter-tag-${filterItem.id}`"
    @click.stop.prevent="toggleTag"
  >
    <span class="sf-label" :class="labelClass">{{ tagName }}</span>
    <div class="sf-font-xs sf-font-medium sf-c-text-dark">
      <span v-if="countActive" :class="countActiveClass">{{
        countActive
      }}</span>
      <span v-if="countActive" class="sf-c-text-light">&nbsp;/&nbsp;</span>
      <span :class="countTotalClass">{{ countTotal }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { AdjustmentFilterKeys } from '../types'

import { computed } from 'vue'

defineOptions({
  name: 'FilterTag',
})

interface Props {
  adjustmentKey: AdjustmentFilterKeys
  countActive: number
  countTotal: number
  filterItem: {
    id: number | string
    name: string
  }
}

const props = defineProps<Props>()

const emit =
  defineEmits<{
    toggleTag: [
      {
        checked: boolean
        key: AdjustmentFilterKeys
        filterId: number | string
      }
    ]
  }>()

const countActiveClass = computed(() => ({
  'sf-c-warning-light-1': props.countActive < props.countTotal,
}))

const countTotalClass = computed(() => ({
  'sf-c-text-light': !props.countActive,
}))

const hasAdjustments = computed(() => props.countTotal > 0)

const labelClass = computed(() => ({
  'sf-label-primary sf-label-active': isChecked.value,
  'sf-label-primary': isPartiallyChecked.value,
}))

const isChecked = computed(
  () => props.countActive === props.countTotal && props.countTotal > 0
)

const isPartiallyChecked = computed(
  () => props.countActive < props.countTotal && props.countActive > 0
)

const tagName = computed(() => props.filterItem.name)

function toggleTag() {
  emit('toggleTag', {
    checked: !isChecked.value,
    key: props.adjustmentKey,
    filterId: props.filterItem.id,
  })
}
</script>
